<template lang="pug">
td.td
    div( :data-id="period.id" v-if="type == 'prim'")
        .td__period {{ period.name }}
        .td__period.td__period_bottom {{ period.name }}
        .td__img( :style='{"background-image": "url("+ period.photo.full +")"}')
        .row__img( :style='{"background-image": "url("+ periods[periods.length -1 ].photo.full +")"}')
        .cell
            div(v-for="(block, id) in mainArr")
                //- .cell__block.cell__block_prim.cell__block_add( 
                //-     v-for="(b, i) in block.primary"
                //-     v-if=" b && b.products[0].additional_product != null && b.startAdd == period.id && b.level == rowLevel"
                //-     :style="{width: 'calc(-1px + ' + (100 * ( fhp(b.endAdd) - fhp(b.startAdd) )) +  '%)','background-color': b.products[0].product.catalogs[0].color }"
                //-     :data-end="fhp(b.endAdd)"
                //-     :data-start="fhp(b.startAdd)"
                    
                    
                    
                //- )
                    
                //-     .cell__content
                //-         span {{ b.products[0].additional_product}}
                //-         span {{ b.products[0].additional_product_consumption_rate }}
            
                    
                router-link.cell__block.cell__block_prim.cell__block_main( 
                    ref='block1'
                    v-for="(b, ind) in block.primary"
                    v-if=" b && b.products[0].product.start == period.id && b.level == rowLevel && b.products[0].additional_product != null"
                    :style="{width: 'calc(' + calcWidth(fhp(b.products[0].product.end), fhp(b.products[0].product.start), 2 ) +  'px)','background-color': b.products[0].product.catalogs[0].color }"
                    :key="ind"
                    :to="'/products/' + b.products[0].product.catalogs[0].slug + '/' + getProductRouteByName(b.products[0].product.id)"
                    :data-end="fhp(b.products[0].product.end)"
                    :data-start="fhp(b.products[0].product.start)"
                    :data-type="'hassAdd'"
                )
                    .cell__plus( :style="{ 'background-color': b.products[0].product.catalogs[0].color }") 
                        .cell__content
                            span {{ b.products[0].product.name }}
                            span {{ b.products[0].consumption_rate }}
                        .cell__plus_before( v-if="b.products[0].additional_product != null") 
                            .cell__plus_before-cont
                    .test
                         .cell__block.cell__block_prim.cell__block_add( 
                            :style="{'background-color': b.products[0].product.catalogs[0].color }"
                        )
                            .cell__content
                                span {{ b.products[0].additional_product}}
                                span {{ b.products[0].additional_product_consumption_rate }}
                
                router-link.cell__block.cell__block_prim.cell__block_single( 
                    v-for="(b, ind) in block.primary"
                    v-if=" b && b.products[0].product.start == period.id && b.level == rowLevel && b.products[0].additional_product == null"
                    :style="{width: 'calc(' + calcWidth(fhp(b.products[0].product.end), fhp(b.products[0].product.start), 1 ) +   'px)','background-color': b.products[0].product.catalogs[0].color }"
                    :key="ind"
                    :to="'/products/' + b.products[0].product.catalogs[0].slug + '/' + getProductRouteByName(b.products[0].product.id)"
                    :data-end="fhp(b.products[0].product.end)"
                    :data-start="fhp(b.products[0].product.start)"
                    :data-type="'hasNoAdd'"
  
                    
                )
                    .cell__plus( :style="{ 'background-color': b.products[0].product.catalogs[0].color }") 
                        .cell__content
                            span {{ b.products[0].product.name }}
                            span {{ b.products[0].consumption_rate }}
                        .cell__plus_before( v-if="b.products[0].additional_product != null")
                            .cell__plus_before-cont
                    
    div( :data-id="period.id" v-if="type == 'sec'")
        .cell
            div(v-for="(block, id) in mainArr")
                //- .cell__block.cell__block_secondary.cell__block_add( 
                //-     v-for="(s, i) in block.secondary"
                //-     v-if=" s && s.products[0].additional_product != null && s.startAdd == period.id && s.level == rowLevel"
                //-     :style="{width: 'calc(-1px + ' + (100 * ( fhp(s.endAdd) - fhp(s.startAdd) )) +  '%)','background-color': s.products[0].product.catalogs[0].color }"
                    
                    
                //- )
             
                //-     .cell__content
                //-         span {{ s.products[0].additional_product}}
                //-         span {{ s.products[0].additional_product_consumption_rate }}

                router-link.cell__block.cell__block_secondary.cell__block_main( 
                    ref='block'
                    v-for="(s, index) in block.secondary"
                    v-if=" s && s.products[0].product.start == period.id && s.level == rowLevel && s.products[0].additional_product != null"
                    :style="{width:  'calc(' + calcWidth(fhp(s.products[0].product.end), fhp(s.products[0].product.start), 2 ) +  'px)','background-color': s.products[0].product.catalogs[0].color }"
                    :key="index"
                    :to="'/products/' + s.products[0].product.catalogs[0].slug + '/' + getProductRouteByName(s.products[0].product.id)"
                )
                    .cell__plus( :style="{ 'background-color': s.products[0].product.catalogs[0].color }")
                        .cell__content
                            span {{ s.products[0].product.name }}
                            span {{ s.products[0].consumption_rate }}
                        .cell__plus_before( v-if="s.products[0].additional_product != null")
                            .cell__plus_before-cont
                    .test
                        .cell__block.cell__block_secondary.cell__block_add( 
                            :style="{'background-color': s.products[0].product.catalogs[0].color }"
                        )
                    
                            .cell__content
                                span {{ s.products[0].additional_product}}
                                span {{ s.products[0].additional_product_consumption_rate }}
                
                router-link.cell__block.cell__block_secondary.cell__block_single( 
                    v-for="(s, index) in block.secondary"
                    v-if=" s && s.products[0].product.start == period.id && s.level == rowLevel && s.products[0].additional_product == null"
                    :style="{width:  'calc(' + calcWidth(fhp(s.products[0].product.end), fhp(s.products[0].product.start), 1 ) +  'px)','background-color': s.products[0].product.catalogs[0].color }"
                    :key="index"
                    :to="'/products/' + s.products[0].product.catalogs[0].slug + '/' + getProductRouteByName(s.products[0].product.id)"
                )
                    .cell__plus( :style="{ 'background-color': s.products[0].product.catalogs[0].color }")
                        .cell__content
                            span {{ s.products[0].product.name }}
                            span {{ s.products[0].consumption_rate }}
                        .cell__plus_before( v-if="s.products[0].additional_product != null")
                            .cell__plus_before-cont

    .divider( v-if="period.id == startDivider && type == 'sec'")
        .divider__container Або
            .divider__line(:style="{width:  (200 * 1.04 * ( fhp(endDivider) - fhp(startDivider) )) +  '%' }")
    

                    
        
		
				
</template>

<script>
    import { mapGetters } from 'vuex';


	export default {
		name: 'Cell',
		data: function(){
			return {
                startDivider: null,
                endDivider: null,
                mainArr: [],
                realCellWidth: null,
			}
        },
        props: {
            period: Object,
            oneCrop: Array,
            horPos: Array,
            rowLevel: Number,
            periods: Array,
            type: String
        },
        computed: {
            ...mapGetters ([
                'getProductRouteByName'
            ])
        },
		methods: {
           
            setField() {
                if(this.oneCrop.length != 0) {
                    let obj = {};
                    let startMass = [];
                    let endMass = [];
                    let one = this.oneCrop.filter(item => item.level == this.rowLevel);
                    if(one.length != 0) {
                        one.forEach(item => {
                            if(item.secondary.length) {
                                item.primary.forEach(block => {
                                    startMass.push(this.fhp(block.start));
                                    startMass.push(this.fhp(block.startAdd));
                                    endMass.push(this.fhp(block.products[0].product.end));
                                    endMass.push(this.fhp(block.endAdd));
                                });
                                item.secondary.forEach(sec => {
                                    startMass.push(this.fhp(sec.start));
                                    startMass.push(this.fhp(sec.startAdd));
                                    endMass.push(this.fhp(sec.products[0].product.end));
                                    endMass.push(this.fhp(sec.endAdd));
                                });

                                obj.start = Math.min.apply(null, startMass);
                                obj.end = Math.max.apply(null, endMass);
                                obj.white = true;

                                this.startDivider = this.horPos[obj.start];
                                this.endDivider = this.horPos[obj.end];

                                this.$emit('white-field', obj );

                            }
                        
                        })

                       
                    }
                
                }
            },
            sortMass() {
                if(this.oneCrop.length) {
                    this.oneCrop.forEach(item => {
                        if(item.primary.length > 1) {
                            item.primary.forEach((block, i) => {
                                if( block.products[0].additional_product == null ) {
                                    item.primary.push(item.primary.splice(i, 1)[0]);
                                }
                            })
                        }

                        if(item.secondary.length != 0 &&  item.secondary.length > 1) {
                            item.secondary.forEach((sec, j) => {
                                if( sec.products[0].additional_product == null) {
                                    item.secondary.push(item.secondary.splice(j, 1)[0]);
                                }
                            })
                        }
                       
                        
                    })

                    this.mainArr = this.oneCrop;
                }
            },
            calcCell() {
                let cell = document.querySelector('.td');
                return cell.clientWidth.toFixed(0);
            },
            fhp(id) {
				return this.horPos.indexOf(id);
            },
            calcWidth(end, start, divider) { // end - конечный период , start - стартовый период , divider - делитель, в случае добавленного продукта
                let rw = Math.floor(1280 / (this.periods.length - 1)); // ширини ячейки с округлением вниз
                // let addition = (1280 / (this.periods.length - 1)) - rw; // остаток от округления вниз 
                return (rw * (end - start)  ) / divider - 1; // сдесь должно получаться полное заполнение без пробелов. + Math.floor(addition * (end - start))

            }
		
		},
		components: {
        },
        mounted() {
            this.sortMass();
            this.setField();
            this.calcWidth();
           
        }
		
	}

</script>

<style lang="scss" scoped>

	@import '@/helpers/sass/kit.scss';

    // table {
    //     min-width: 100%;
    //     table-layout: fixed;

    // }

    // tr {
    //     width: 100%;
    // }

    // td {

    // }

    // tr {
    //     height: 0;
    // }

    // .secondary {
    //     .cell {
    //         min-height: 0;
    //     }
    // }

</style>